import styled, { css } from 'styled-components'

import { Tooltip } from '@blade/ui-kit'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'
type TradeSettingsLabelProps = {
  toolTipMessage?: string
} & ClassNameProps &
  ChildrenProps

export const TradeSettingsLabel: React.FC<TradeSettingsLabelProps> = ({
  toolTipMessage,
  className,
  children,
}) => (
  <Root>
    <TooltipStyled content={toolTipMessage} side="top" align="start">
      <Caption className={className} $withTooltip={Boolean(toolTipMessage)}>
        {children}
      </Caption>
    </TooltipStyled>
  </Root>
)

const TooltipStyled = styled(Tooltip)`
  max-width: 300px;
`

const Root = styled.div`
  padding-block: 12px 6px;
`

const Caption = styled.div<{ $withTooltip?: boolean }>`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  word-break: break-word;

  display: inline-grid;
  grid-template-columns: auto 1fr;
  align-items: center;

  gap: 6px;

  ${({ $withTooltip }) => {
    if ($withTooltip) {
      return css`
        &:hover {
          cursor: help;
        }
      `
    }
  }}
`
